module.exports = __webpack_public_path__ + "static/media/homepage3.5e4de51e.webp";